import React, { useState } from 'react';
import { useOrderExtraction } from '../../contexts/OrderExtractionContext';
import './ExtractedItem.css';

const ExtractedItem = ({ 
  item, 
  itemIndex, 
  onOpenSearch 
}) => {
  const { actions } = useOrderExtraction();

  const hasSelectedProduct = () => {
    return item.selectedProductCode && item.selectedProductCode.trim() !== '';
  };

  const [isCollapsed, setIsCollapsed] = useState(hasSelectedProduct());
  const [quantityInput, setQuantityInput] = useState(item.quantity);
  const [showIgnoreConfirm, setShowIgnoreConfirm] = useState(false);

  
  const handleQuantityChange = async (newQuantity) => {
    setQuantityInput(newQuantity);
    try {
      await actions.updateItemQuantity(item.id, item.id, newQuantity);
    } catch (error) {
      alert('Erro ao atualizar quantidade.');
    }
  };

  const handleIgnoreToggle = () => {
    setShowIgnoreConfirm(true);
  };

  const handleConfirmIgnore = async () => {
    try {
      await actions.setItemIgnored(item.id, item.id, true);
      setShowIgnoreConfirm(false);
    } catch (error) {
      alert('Erro ao ignorar item.');
    }
  };

  const handleCancelIgnore = () => {
    setShowIgnoreConfirm(false);
  };

  const handleCandidateSelect = async (candidate) => {
    try {
      await actions.selectProductCode(item.id, item.id, candidate.productCode);
      // Auto-collapse the item after selection
      setIsCollapsed(true);
    } catch (error) {
      alert('Erro ao selecionar produto.');
    }
  };

  const handleToggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  const handleOpenSearch = () => {
    if (onOpenSearch) {
      onOpenSearch(itemIndex, item.productCode);
    }
  };

  const hasSelected = hasSelectedProduct();

  // Confirmation dialog for ignoring item
  if (showIgnoreConfirm) {
    return (
      <div className="extracted-item ignore-confirm-dialog">
        <div className="ignore-confirm-content">
          <div className="ignore-confirm-header">
            <h4>⚠️ Confirmar Ignorar Item</h4>
          </div>
          <div className="ignore-confirm-body">
            <p>Tem certeza que deseja ignorar este item?</p>
            <div className="item-preview">
              <strong>Item {itemIndex + 1}:</strong> {item.productCode}
              {item.observation && (
                <span> | {item.observation}</span>
              )}
            </div>
            <p className="ignore-warning">
              <small>Este item será movido para a seção "Itens Ignorados" e não será incluído no pedido final.</small>
            </p>
          </div>
          <div className="ignore-confirm-actions">
            <button 
              className="btn btn-secondary"
              onClick={handleCancelIgnore}
            >
              Cancelar
            </button>
            <button 
              className="btn btn-danger"
              onClick={handleConfirmIgnore}
            >
              Sim, Ignorar
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Return collapsed version if collapsed
  if (isCollapsed) {
    return (
      <div className={`extracted-item collapsed` + (hasSelected ? ' has-selected' : '')}>
        <div className="item-header" onClick={handleToggleCollapse}>
          <div className="item-info">
            <span className="item-number">Item {itemIndex + 1}</span>
            <span className="item-name">{item.productCode}</span>
            {item.observation && (
              <span className="item-observation">| {item.observation}</span>
            )}
          </div>
          <div className="item-actions">
            <button 
              className="collapse-btn"
              onClick={(e) => {
                e.stopPropagation();
                handleToggleCollapse();
              }}
              title="Expandir item"
            >
              ▶️
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Return full expanded version
  return (
    <div className={`extracted-item ${hasSelected ? 'has-selected' : ''}`}>
      <div className="item-header" onClick={() => hasSelected && handleToggleCollapse()}>
        <div className="item-info">
          <span className="item-number">Item {itemIndex + 1}</span>
          <span className="item-name">{item.productCode}</span>
          {item.observation && (
            <span className="item-observation">| {item.observation}</span>
          )}
        </div>
        <div className="item-actions">
          <button 
            className="ignore-btn"
            onClick={handleIgnoreToggle}
            title="Ignorar item"
          >
            ✕
          </button>
          <button 
            className="search-btn"
            onClick={handleOpenSearch}
            title="Pesquisar produtos"
          >
            🔍
          </button>
          <button 
              className="collapse-btn"
              onClick={(e) => {
                e.stopPropagation();
                handleToggleCollapse();
              }}
              title="Colapsar item"
            >
              ▼
            </button>
        </div>
      </div>

      <div className="item-content">
        <div className="quantity-section">
          <label>Quantidade:</label>
          <input
            type="number"
            value={quantityInput}
            onChange={(e) => handleQuantityChange(parseFloat(e.target.value) || 0)}
            min="0"
            step="0.01"
            className="quantity-input"
          />
          <span className="unit">{item.unityOfMeasure || 'UN'}</span>
        </div>

        {/* Product Candidates */}
        {item.candidates && item.candidates.length > 0 ? (
          <div className="candidates-section">
            <h5>Candidatos de Produto ({item.candidates.length})</h5>
            <div className="candidates-list">
              {item.candidates.map((candidate, candidateIndex) => (
                <div 
                  key={candidateIndex} 
                  className={`candidate-item ${item.selectedProductCode === candidate.productCode ? 'selected' : ''}`}
                  onClick={() => handleCandidateSelect(candidate)}
                >
                  <div className="candidate-info">
                    <span className="candidate-code">{candidate.productCode}</span>
                    <span className="candidate-description">{candidate.productDescription}</span>
                    <span className="candidate-unit">{candidate.unityOfMeasure}</span>
                  </div>
                  {item.selectedProductCode === candidate.productCode && (
                    <div className="selected-badge">✓ Selecionado</div>
                  )}
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="no-candidates">
            <span className="no-candidates-text">⚠️ Nenhum candidato encontrado</span>
            <button 
              className="search-btn"
              onClick={handleOpenSearch}
              title="Pesquisar produtos"
            >
              🔍 Pesquisar
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ExtractedItem;
